import { IDomainConfig } from '../../interfaces/IConfig'

export const config: IDomainConfig = {
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID!,
  API_SERVER: process.env.REACT_APP_API_SERVER!,
  OAUTH_SERVER: process.env.REACT_APP_OAUTH_SERVER!,
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI!,
}

